<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards></imgBigCards> -->

    <!-- 内容盒子 -->
    <div class="correction-content">
      <p>活动报名</p>
      <!-- 输入框 + 按钮 盒子 -->
      <div class="text-input">
        <el-form
          style="max-width: 343px"
          :model="mydata.form"
          :rules="mydata.rules"
          label-width="55"
          class="demo-ruleForm"
          ref="formEl"
          label-position="top"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="mydata.form.name" placeholder="请填写您的姓名" />
          </el-form-item>

          <el-form-item label="学校" prop="school" width="59px">
            <el-input
              v-model="mydata.form.school"
              placeholder="请填写您的学校"
            />
          </el-form-item>

          <!-- <el-form-item label="年级" prop="grade" class="this-title">
            <el-input v-model="mydata.form.grade" />
          </el-form-item> -->

          <!-- <el-form-item label="年级" prop="grade">
            <el-select v-model="mydata.form.grade" placeholder="请选择您的年级">
              <el-option
                v-for="item in mydata.gradeIdOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item> -->

          <el-form-item label="电话" prop="tel">
            <el-input v-model="mydata.form.tel" placeholder="请填写您的电话" />
          </el-form-item>

          <el-form-item
            label="作品上传"
            class="this-annex"
            prop="upload_photos"
          > 
            <!-- 仅可图片上传 -->
            <!-- <el-upload
              :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
              :auto-upload="true"
              :on-success="successFile1"
              list-type="picture-card"
              :on-change="uploadChange1"
              :on-remove="uploadRemove1"
              :on-preview="uploadPreview1"
              :class="{ hiddenUpload: mydata.hiddenUpload1 }"
              accept=".jpg,.jpeg,.png,.gif"
              :file-list="mydata.fileList1"
              :show-file-list="true"
            >
              <el-icon><Plus /></el-icon>
            </el-upload> -->

             <!-- 以上是仅可图片上传 -->
            <!-- 可支持word文稿和pdf格式文件上传 -->
            <el-upload
              ref="refUpload"
              :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
              :auto-upload="true"
              :on-success="successFile1"
              list-type="text"
              :on-change="uploadChange1"
              :on-remove="uploadRemove1"
              :on-preview="uploadPreview1"
              :class="{ hiddenUpload: mydata.hiddenUpload1 }"
              accept=".jpg,.jpeg,.png,.gif,.doc,.docx,.pdf"
              :file-list="mydata.fileList1"
              :show-file-list="true"
              :limit="1"
              :multiple="false"
              :on-exceed="exceedFile"
            >
              <el-icon><Plus /></el-icon>
            </el-upload>
            <!-- 以上是可支持word文稿和pdf格式文件上传 -->

            <el-dialog v-model="mydata.dialogVisible5">
              <img width="100%" v-complete:src="mydata.dialogImageUrl5" />
            </el-dialog>
            <div class="tip-div" style="color: #999; line-height: 20px; margin-top: 15px">
              <p>点击上传您准备好的作品</p>
              <p>作品格式支持：.jpg .jpeg .png .gif .doc .docx .pdf</p>
              <p>文件大小限制：文件大小请控制在5M之内</p>
            </div>
            <!-- <el-upload
             class="upload-demo"
              :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
              :auto-upload="true"
              :on-success="successFile1"
              list-type="picture-card"
              :on-change="uploadChange1"
              :on-remove="uploadRemove1"
              :on-preview="uploadPreview1"
              :class="{ hiddenUpload: mydata.hiddenUpload1 }"
              :file-list="mydata.fileList1"
              :show-file-list="true"
            >
             <template #trigger>
                <el-button type="default" class="submit-button"
                  >请选择小于10M的文件进行上传</el-button
                >
              </template>
            </el-upload> -->
          </el-form-item>
        </el-form>

        <!-- 提交按钮 -->
        <el-button
          type="primary"
          @click="submitButton"
          :loading="mydata.btnLoading"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "thisEventRegistrationStudent",
});
</script>

<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import imgBigCards from "@/components/imgBigCards/index.vue";

// 引入接口
import { get_grade } from "@/api/login/nowLogin/index.js";

// 引入接口
import { getStudentActivities } from "@/api/enterActivities/index.js";

const refUpload = ref()
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  form: {
    name: "",
    school: "",
    // grade: "",
    // email: "",
    tel: "",
    upload_photos: [],
  },
  gradeIdOptions: [],

  rules: {
    name: [
      {
        required: true,
        message: "请填写您的姓名",
        trigger: "blur",
      },
    ],
    school: [
      {
        required: true,
        message: "请填写您的单位",
        trigger: "blur",
      },
    ],
    // grade: [
    //   {
    //     required: true,
    //     message: "请选择您的年级",
    //     trigger: "change",
    //   },
    // ],
    // email: [
    //   {
    //     required: true,
    //     message: "请填写您的邮箱",
    //     trigger: "blur",
    //   },
    // ],
    tel: [
      {
        required: true,
        message: "请填写您的电话",
        trigger: "blur",
      },
    ],

    upload_photos: [
      {
        required: true,
        message: "请上传附件",
      },
    ],
  },
  btnLoading: false,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  articleId: "", //文章id

  xx: "/api/sale_auth/upload_file",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  hiddenUpload1: false,
  dialogVisible1: false,
  dialogImageUrl1: "",
  fileList1: [],
  fiveM1: 1024 * 1024 * 5, // 单位字节B
});

const formEl = ref(null);

mydata.articleId = route.query.id;

function exceedFile() {
  // 提示弹窗
  ElMessage({
    message: "只可上传一个文件",
    type: "warning",
  });
}

//点击事件
function submitButton() {
  // router.push({
  //   path: "/layout/list/reviewQualificationsStep2",
  // });

  formEl.value.validate((valid, fields) => {
    if (valid) {
      // console.log(mydata.form);
      // return

      // 调用学生加入活动
      getStudentActivities(
        {
          article_id: mydata.articleId,
          ...mydata.form,
          files: mydata.form.upload_photos.join(","),
        },
        mydata.userInfo.jwt
      ).then((res) => {
        // console.log("111", res);
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });

        router.push({
          path: "/layout/list/personalCenter/myActivity",
        });
        // mydata.enterActivitiesList = res.data;
      });
    }
  });
}

// 文件改变事件
function uploadChange1(file, fileList) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM1) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 赋值
    mydata.fileList1 = [];
  } else {
    // 赋值
    mydata.fileList1 = fileList;
    // 赋值
    mydata.hiddenUpload1 = mydata.fileList1.length === 10 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList1);
}

// 文件移除事件
function uploadRemove1(file, fileList) {
  // 赋值
  mydata.fileList1 = fileList;
  // 赋值
  mydata.hiddenUpload1 = mydata.fileList1.length === 10 ? true : false;
  // 赋值
  mydata.form.upload_photos = fileList.map((item) => {
    return item.response.data.url;
  });
}

// 文件预览事件
function uploadPreview1(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible1 = true;
  // 赋值地址
  mydata.dialogImageUrl1 = file.url;
}

// 出版物许可证-文件上传成功
function successFile1(val) {
  if (val.code!==200) {
        ElMessage({
        message: val.msg,
        type: "error",
      });
      mydata.fileList1 = []
      refUpload.value?.clearFiles()
      return
  }
  mydata.form.upload_photos.push(val.data.url);
  // console.log(mydata.form);
}

function init() {
  // get_grade_group().then((res) => {
  //   mydata.study_stageOptions = res.data;
  // });
  get_grade().then((res) => {
    mydata.gradeIdOptions = res.data;
  });
}

init();

// function handleClick(tab) {
//   console.log(tab);
// }

//按钮的事件函数
// function submit() {

// console.log(mydata.zhanghao, mydata.mima);
// mydata.btnLoading = true;
// axios({
//   method: "post",
//   url: "/house/login/login",
//   data: {
//     //请求参数（get请求的时候必须用params，post请求的时候必须用data）
//     account: mydata.zhanghao,
//     password: mydata.mima,
//     // sourceText: mydata.zhanghao + mydata.mima, //sourceText就是这次项目的后端跟你说的必须用什么属性名，否则后端就拿不到了；属性值是我要传给后端的内容
//   },
// }).then((res) => {
//   mydata.btnLoading = false;
//   if (res.data.code === 1) {
//     ElMessage({
//       message: res.msg,
//       type: "success",
//     });

//     // 存储后端返回的token值
//     localStorage.setItem("token", res.data.data.token);
//     localStorage.setItem("adminName", mydata.zhanghao);

//     // 跳转页面
//     router.push({
//       path: "/layout/list/personalCenter/personalInfor/index.vue",
//     });

//     mydata.zhanghao = "";
//     mydata.mima = "";
//   }
// });
// }
</script>

<style scoped lang="scss">
.books-details {
  padding-top: 16px;
  // // padding: 40px 65px;
  background-color: #ffffff;
  overflow: hidden;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //内容盒子
  .correction-content {
    width: 343px;
    margin: 0 auto;
    // padding: 40px 65px;
    // background-color: #ffffff;
    // box-shadow: 0px 5px 40px 0px #0000000d;
    // border-radius: 8px;
    //活动报名
    > p {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      text-align: center;
      line-height: 50px;
      text-shadow: 0px 2px 8px 0px #0000004d;
      background-color: #009de0;
      border-radius: 8px;
    }

    ////// 输入框 + 按钮 盒子  ////////////////////////////////////
    .text-input {
      margin: 0 auto;
      // border: 1px solid blue;
      margin-top: 20px;
      margin-bottom: 40px;
      overflow: hidden;

      //输入框的长度（包括字体）
      :deep(.el-form-item) {
        // display: flex;
        // flex-direction: column;
        .el-input__wrapper {
          height: 40px;
        }
        //字体
        .el-form-item__label {
          width: 59px !important;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          // text-align: left;
        }
      }

      //下拉框
      :deep(.el-form-item.is-required.asterisk-left) {
        margin-bottom: 20px;
        // 下拉框高度
        .el-select__wrapper.el-tooltip__trigger.el-tooltip__trigger {
          height: 40px;
        }
      }

      //上传附件（文字 + 输入框）
      :deep(.el-form-item.asterisk-left.this-annex) {
        // display: flex;
        // flex-direction: column;
      }
      :deep(.el-form-item.is-required.asterisk-left.this-annex) {
        //字体
        .el-form-item__label {
          width: 88px !important;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          // border:1px solid blue;
          // margin-left: 1px;
        }

        //作品上传的框框大小
        .el-form-item__content {
          // 放大图标
          .el-upload-list__item-preview{
            display: none;
          }
          // 删除图标
          .el-upload-list__item-delete{
            margin-left:0px;
          }
          .el-upload-list.el-upload-list--picture-card {
            // margin-right: 20px;
            .el-upload.el-upload--picture-card {
              width: 100px;
              height: 100px;
            }
          }

          .el-upload-list__item.is-success {
            width: 100px;
            height: 100px;
            .el-upload-list__item-actions {
              width: 100px;
              height: 100px;
            }
          }
        }
      }

      ////// 按钮
      :deep(.el-button.el-button--primary) {
        width: 343px;
        height: 40px;
        border-radius: 4px;
        margin-top: 40px;
        margin-bottom: 40px;

        > span {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}

:deep(.el-upload.el-upload--picture-card) {
  // display: flex;
  // flex-direction: column;
  // border:1px solid pink;
  > p {
    color: #333333;
    font-size: 14px;
    margin-top: 10px;
  }
}

:deep(.el-form-item.asterisk-left.this-annex) {
  :deep(.el-icon) {
    color: #009de0;
    font-size: 24px;
    > p {
      color: #333333;
      font-size: 14px;
      margin-top: 10px;
    }
  }
}

//作品上传————可支持word文稿和pdf格式文件上传  的样式
:deep(.el-form-item__content) {
  padding-left:20px;
  display: block;
  .el-upload-list.el-upload-list--picture-card {
    // margin-right: 30px;
    .el-upload.el-upload--picture-card {
      width: 312px !important;
      height: 32px !important;
      border:1px solid red;
    }
  }

  .el-upload-list__item.is-success {
    width: 312px !important;
    height: 32px !important;
    .el-upload-list__item-actions {
      width: 312px !important;
      height: 32px !important;
    }
  }
}
.tip-div{
  margin-top:30px;
  margin-left:10px;
}
// +号图标
:deep(.el-upload.el-upload--text){
  font-size:25px !important;
  }

//作品上传————以上是可支持word文稿和pdf格式文件上传  的样式
</style>
